export default {
  sections: {
    address: 'Adres firmy',
    address_help: 'Wpisz adres, pod którym zarejestrowana jest Twoja firma. Jest on drukowany na fakturach.',
  },
  form: {
    legal_form: {
      label: 'Rodzaj działalności',
      help: 'UG (haftungsbeschränkt) odpowiada tu GmbH, e.K. – jednoosobowej działalności. W przypadku OHG lub KG skontaktuj się z pomocą techniczną.',
      options: {
        sole_trader: 'Jednoosobowa działalność',
        gbr: 'GbR',
        gmbh: 'GmbH / UG',
      },
    },
    legal_name: {
      label: 'Zarejestrowana nazwa firmy',
      placeholder: 'Wpisz zarejestrowaną nazwę firmy',
      sole_trader_help: 'Pozostaw puste, jeśli działasz pod własnym imieniem i nazwiskiem',
    },
  },
  buttons: {
    next: 'Dalej',
  },
};
